module.exports = __webpack_public_path__ + "media/bg-video2.e2cc6f7c.mp4";